import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "swatch", "preview", "previewText"]
  static values = { colors: Object }

  connect() {
    this.updateSelection()
  }

  select(event) {
    const color = event.currentTarget.dataset.color
    this.inputTarget.value = color
    this.updateSelection()
  }

  updateSelection() {
    const selectedColor = this.inputTarget.value || "gray"

    // Update swatch selection state
    this.swatchTargets.forEach(swatch => {
      const isSelected = swatch.dataset.color === selectedColor
      if (isSelected) {
        swatch.classList.add("ring-2", "ring-offset-2", "ring-blue-500")
      } else {
        swatch.classList.remove("ring-2", "ring-offset-2", "ring-blue-500")
      }
    })

    // Update preview badge
    if (this.hasPreviewTarget && this.colorsValue[selectedColor]) {
      const colorConfig = this.colorsValue[selectedColor]
      this.previewTarget.style.backgroundColor = colorConfig.bg
      this.previewTarget.style.color = colorConfig.color
    }
  }
}
